
import React from 'react';
import { withTranslation } from "react-i18next";
import { BsBoxArrowLeft, BsEye, BsFileWord, BsFileEarmarkPdf } from 'react-icons/bs';
import { BiDownload } from 'react-icons/bi';
import { Dropdown, Form, OverlayTrigger, Button } from "react-bootstrap";
import './Reporting.scss';

const FloatingActionBarForReport = ({ t, onGenerateWord, onGeneratePDF, onSave, onExit }) => {

	return (
		<div className='floating-action-bar'>
			<Dropdown>
				<Dropdown.Toggle variant="light" id="dropdown-basic" className='btn me-2'>
					<BiDownload /> {t("Download.label")}
				</Dropdown.Toggle>
				<Dropdown.Menu className="CustomizeColumns_drop p-2">
					<Dropdown.Item onClick={() => onGenerateWord()}><BsFileWord /> {t("MSWord.label")}</Dropdown.Item>
					<Dropdown.Item onClick={() => onGeneratePDF()}><BsFileEarmarkPdf /> {t("Pdf.label")}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>


			<Button variant='primary' className='me-2 px-4'
				onClick={() => onSave()}> {t("Save.label")}
			</Button>
			<Button variant='primary' onClick={() => onExit()}><BsBoxArrowLeft />  Exit</Button>
		</div>
	);

}

export default withTranslation()(FloatingActionBarForReport);
